export default function getPricingIsHidden({session, productOrder}) {
  return _.get(session.user, 'orgAccessEdgeData.designEngine.pricingIsHidden') || _.get(productOrder, `involvedUsers.${session.user.id}.pricingIsHidden`);
}
